
import AppButton from "@/components/AppButton.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import axios from "axios";
import LoginModal from "shared-components/LoginModal.vue";
import { Component, Vue } from "vue-property-decorator";
import { TYPE } from "vue-toastification";
import ModalCodigo from "../components/ModalCodigo.vue";

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

// Interface para o objeto place
interface Place {
  address?: {
    road?: string;
    neighbourhood?: string;
    city?: string;
    town?: string;
    village?: string;
    state?: string;
    postcode?: string;
    suburb?: string;
  };
  address_components?: AddressComponent[];
  geometry?: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
  lat?: number; // Latitude caso venha do Nominatim
  lon?: number; // Longitude caso venha do Nominatim
}

// Interface para o resultado dos componentes do endereço
interface AddressComponents {
  street: string;
  neighbourhood: string;
  city: string;
  state: string;
  zipCode: string;
  lat: string;
  lon: string;
}

declare let google: any;

@Component({
  components: {
    AppButton,
    HeaderRelease,
    ModalCodigo,
  },
})
export default class AddAddress extends Vue {
  latitude = sessionStorage.getItem("LATITUDE") || "";
  longitude = sessionStorage.getItem("LONGITUDE") || "";
  cameFromQrCode = JSON.parse(
    sessionStorage.getItem("CAME_FROM_QRCODE") || "false"
  );
  homeLayout = sessionStorage.getItem("HOME_LAYOUT") || "feed";
  showModal = false;
  modalMessage = "";
  errorCode = 0;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    callback: this.goBack,
  };
  nrorg = Number(sessionStorage.getItem("NRORG"));
  showAddManualAddress = true;
  userId = sessionStorage.getItem("USER_ID");

  // Delivery variables
  addressInputDelivery = "";
  cepInputDelivery = "";
  provincyInputDelivery = "";
  cityInputDelivery = "";
  neighInputDelivery = "";
  streetInputDelivery = "";
  numberInputDelivery = "";
  complementInputDelivery = "";
  oldCepInputDelivery: any = "";
  oldNumberInputDelivery: any = "";
  oldStreetInputDelivery: any = "";
  oldNeighborhoodInputDelivery: any = "";
  oldProvinceInputDelivery: any = "";
  oldCityInputDelivery: any = "";
  oldComplementInputDelivery: any = "";
  isDisabledNumber = true;
  isDisabledComplement = true;
  isDisabledNeighborhood = true;
  componentKey = 0;
  placeLocation: any;

  /* Modals configs */
  showModalConfirmCancel = false;
  modalIcon = "error_outline";
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");

  file: any;
  switchBool: any = false;

  // eslint-disable-next-line
  [key: string]: any;

  googleMaps: any;
  place: any;
  placeSelected = false;
  addressChanged = false;
  valid = true;
  rulesComplement: any = [
    (v: any) =>
      v.length <= 100 || "O complemento deve ter, no máximo, 100 caracteres.",
  ];
  rulesNumber: any = [
    (v: any) => v.length <= 5 || "O número deve ter, no máximo, 5 caracteres.",
  ];
  rulesNeigh: any = [
    (v: any) =>
      v.length <= 100 || "O bairro deve ter, no máximo, 100 caracteres.",
  ];
  provisoryCurrentLocation = true;
  modalChecksCurrentLocation = false;
  dialogLoading = false;
  waitingMessage = "Carregando localização atual";
  loginType = { isSimpleLogin: false, simpleLoginType: null };

  // Manual search fields for Massuco (NRORG 5727)
  useManualSearch = false;
  manualStreetInput = "";
  manualNumberInput = "";
  manualNeighInput = "";
  manualCityInput = "";
  manualUFInput = "";

  // Valid Brazilian state abbreviations
  validUFs = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  rulesUF: any = [
    (v: any) => v.length === 2 || "UF deve ter exatamente 2 caracteres.",
    (v: any) =>
      this.validUFs.includes(v.toUpperCase()) ||
      "UF inválida. Use siglas de estados brasileiros.",
  ];

  rulesManualStreet: any = [
    (v: any) => v.length > 0 || "Rua é obrigatória.",
    (v: any) => v.length <= 200 || "Rua deve ter, no máximo, 200 caracteres.",
  ];

  rulesManualNumber: any = [
    (v: any) => v.length > 0 || "Número é obrigatório.",
    (v: any) => v.length <= 5 || "Número deve ter, no máximo, 5 caracteres.",
  ];

  rulesManualNeigh: any = [
    (v: any) => v.length > 0 || "Bairro é obrigatório.",
    (v: any) =>
      v.length <= 100 || "Bairro deve ter, no máximo, 100 caracteres.",
  ];

  rulesManualCity: any = [
    (v: any) => v.length > 0 || "Cidade é obrigatória.",
    (v: any) =>
      v.length <= 100 || "Cidade deve ter, no máximo, 100 caracteres.",
  ];

  get isMassuco(): boolean {
    return this.nrorg === 5727;
  }

  get isManualFormValid(): boolean {
    return (
      this.manualStreetInput.length > 0 &&
      this.manualNumberInput.length > 0 &&
      this.manualNeighInput.length > 0 &&
      this.manualCityInput.length > 0 &&
      this.manualUFInput.length === 2 &&
      this.validUFs.includes(this.manualUFInput.toUpperCase())
    );
  }

  get loginTypeConsumer() {
    this.loginType = JSON.parse(
      sessionStorage.getItem("loginTypeInfo") ||
        '{"isSimpleLogin": false, "simpleLoginType": null}'
    );

    if (
      this.loginType.isSimpleLogin &&
      this.loginType.simpleLoginType == "consumer"
    ) {
      return true;
    } else {
      return false;
    }
  }

  mounted() {
    this.showAddManualAddress = false;
    if (
      this.latitude !== "" &&
      this.longitude !== "" &&
      sessionStorage.getItem("USE_CURRENT_LOCATION") == "true"
    ) {
      this.reverseGeocode(this.latitude, this.longitude);
    }

    // Initialize Google Autocomplete in nextTick to ensure element exists in DOM
    this.$nextTick(() => {
      this.initializeGoogleAutocomplete();
    });
  }

  initializeGoogleAutocomplete() {
    // Only initialize if not already initialized
    if (this.googleMaps && this.googleMaps.setComponentRestrictions) {
      return;
    }

    const input = document.getElementById("searchTextField");
    if (input) {
      const options = {
        componentRestrictions: { country: "br" },
      };
      this.googleMaps = new google.maps.places.Autocomplete(input, options);
      this.googleMaps.addListener(
        "place_changed",
        this.fillAddressAndNumber.bind(this)
      );
    }
  }

  openLoginModal() {
    const loginModal: any = LoginModal;
    loginModal.openLoginModal();
  }

  goToAddAddress() {
    this.$router.push("AddAddress");
    sessionStorage.setItem("MANUAL_ADDRESS", "true");
  }

  verifyRouteHome() {
    let homeLayout: any = Util.verifyRouteHome();
    return homeLayout;
  }

  fechaModal() {
    this.showModal = false;

    if (this.errorCode == 2 || this.errorCode == 3) {
      this.$router.push("AddAddress");
    }
  }

  goBack() {
    if (this.showAddManualAddress) {
      this.showAddManualAddress = false;
    } else {
      this.$router.go(-1);
    }
  }

  cleanFields() {
    this.addressInputDelivery = "";
    this.numberInputDelivery = "";
    this.isDisabledNumber = true;
    this.complementInputDelivery = "";
    this.isDisabledComplement = true;
    this.neighInputDelivery = "";
    this.isDisabledNeighborhood = true;
    this.placeSelected = false;
  }

  cleanManualFields() {
    this.manualStreetInput = "";
    this.manualNumberInput = "";
    this.manualNeighInput = "";
    this.manualCityInput = "";
    this.manualUFInput = "";
  }

  mostraModal(message: string, icon: string) {
    this.modalMessage = message;
    this.modalIcon = icon;
    this.showModal = true;
  }

  fechaModalConfirmCancel() {
    this.showModalConfirmCancel = false;
    this.goBack();
  }

  goBackCancel() {
    this.showModalConfirmCancel = true;
    this.modalMessage =
      "Você tem certeza que vai cancelar? As alterações serão perdidas.";
  }

  goToHomeLayout() {
    if (this.homeLayout === "feed") {
      this.$router.push("HomeFeed");
    } else this.$router.push(this.homeLayout);
  }

  openModalManualAddressPrev() {
    this.provisoryCurrentLocation = false;
    this.cleanFields();
    this.openModalManualAddress();
  }

  openModalManualAddress() {
    this.showAddManualAddress = true;
    this.$nextTick(() => {
      // Initialize Google Autocomplete after the modal is shown
      this.initializeGoogleAutocomplete();
      const input = document.getElementById("searchTextField");
      setTimeout(() => {
        if (input) input.focus();
      }, 100);
    });
  }

  async reverseGeocode(lat: any, lng: any) {
    // URL para a API Nominatim
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;

    try {
      const results = await axios.get(url);

      if (results.data && results.status === 200) {
        const resultado = results.data;

        // Estrutura de endereço com base na resposta do Nominatim
        const addressComponents = resultado.address || {};
        this.address = resultado.display_name;
        this.addressInputDelivery = addressComponents.road || "";
        this.numberInputDelivery = ""; // Adapte conforme necessário
        this.neighInputDelivery =
          addressComponents.neighbourhood || addressComponents.suburb || "";
        this.isDisabledNumber = false;
        this.placeLocation = resultado;
        this.place = resultado;
      } else {
        console.error("Erro ao buscar endereço atual:", results.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  checkAddressCurrentLocation() {
    this.provisoryCurrentLocation = true;
    this.reverseGeocode(this.latitude, this.longitude);
    this.openModalManualAddress();
  }

  openManualSearchMode() {
    this.useManualSearch = true;
    this.cleanManualFields();
  }

  cancelManualSearch() {
    this.useManualSearch = false;
    this.cleanManualFields();
  }

  async searchAddressNominatim() {
    // Validate required fields
    if (
      !this.manualStreetInput ||
      !this.manualNumberInput ||
      !this.manualNeighInput ||
      !this.manualCityInput ||
      !this.manualUFInput
    ) {
      this.mostraModal("Por favor, preencha todos os campos.", "error_outline");
      return;
    }

    // Validate UF format
    if (
      this.manualUFInput.length !== 2 ||
      !this.validUFs.includes(this.manualUFInput.toUpperCase())
    ) {
      this.mostraModal(
        "UF inválida. Use siglas válidas (ex: SP, MG, RJ).",
        "error_outline"
      );
      return;
    }

    this.dialogLoading = true;
    this.waitingMessage = "Buscando endereço...";

    try {
      // Build complete address string
      const addressQuery = `${this.manualStreetInput} ${this.manualNumberInput}, ${this.manualNeighInput}, ${this.manualCityInput}, ${this.manualUFInput}`;
      const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
        addressQuery
      )}&format=json`;

      const response = await axios.get(url, {
        headers: {
          "User-Agent": "generalfrontend/1.0",
        },
      });

      if (response.data && response.data.length > 0) {
        // Always use the first result if multiple addresses are returned
        const result = response.data[0];

        // Set latitude and longitude from Nominatim result
        this.latitude = result.lat;
        this.longitude = result.lon;

        sessionStorage.setItem("LATITUDE", this.latitude);
        sessionStorage.setItem("LONGITUDE", this.longitude);

        // Set address fields from manual input
        this.streetInputDelivery = this.manualStreetInput;
        this.numberInputDelivery = this.manualNumberInput;
        this.neighInputDelivery = this.manualNeighInput;
        this.cityInputDelivery = this.manualCityInput;
        this.provincyInputDelivery = this.manualUFInput.toUpperCase();
        this.complementInputDelivery = "";

        // Set CEP if available from Nominatim
        if (result.address && result.address.postcode) {
          this.cepInputDelivery = result.address.postcode;
        } else {
          this.cepInputDelivery = "30130151"; // Default CEP
        }

        // Set the address field for display
        this.addressInputDelivery = `${this.manualStreetInput}, ${this.manualNumberInput}, ${this.manualNeighInput}, ${this.manualCityInput}`;

        // Mark that address was selected/filled
        this.placeSelected = true;

        // Create a place object for compatibility with checkUpdateAddress validation
        this.place = {
          address: result.address,
          lat: result.lat,
          lon: result.lon,
          formatted_address: this.addressInputDelivery,
        };

        this.dialogLoading = false;
        this.cleanManualFields();

        // Validate that all required fields are filled
        if (!this.validateForm(this.provincyInputDelivery)) {
          this.mostraModal(
            "Por favor, verifique os dados inseridos.",
            "error_outline"
          );
          return;
        }

        // Save address and navigate (same behavior as Continuar button)
        if (!sessionStorage.getItem("USER_ID")) {
          this.storeProvisoryAddress();
        } else {
          this.updateAddressDelivery();
          this.storeOnlyProvisoryAddress();
        }
      } else {
        this.dialogLoading = false;
        this.mostraModal(
          "Endereço não encontrado. Verifique os dados digitados ou use sua localização atual.",
          "error_outline"
        );
      }
    } catch (error) {
      this.dialogLoading = false;
      console.error("Erro ao buscar endereço no Nominatim:", error);
      this.mostraModal(
        "Erro ao buscar endereço. Verifique sua conexão ou tente novamente.",
        "error_outline"
      );
    }
  }

  getLocation() {
    this.dialogLoading = true;
    navigator.geolocation.getCurrentPosition(
      (location: any) => {
        const deliveryAddress =
          this.userData &&
          this.userData.ADDRESS &&
          this.userData.ADDRESS.find(
            (address: any) => address.TYPE == "DELIVERY"
          );

        let differentLocation = false;
        if (deliveryAddress) {
          const margin = 100; // Margem de erro em metros
          differentLocation = this.isDifferentLocationWithMargin(
            deliveryAddress.LATITUDE,
            deliveryAddress.LONGITUDE,
            location.coords.latitude,
            location.coords.longitude,
            margin
          );
        }

        this.latitude = location.coords.latitude;
        this.longitude = location.coords.longitude;
        this.reverseGeocode(this.latitude, this.longitude);
        sessionStorage.setItem("LATITUDE", this.latitude);
        sessionStorage.setItem("LONGITUDE", this.longitude);

        if (deliveryAddress && differentLocation) {
          this.modalChecksCurrentLocation = true;
        } else if (location) {
          this.provisoryCurrentLocation = true;
          this.openModalManualAddress();
        }
        this.dialogLoading = false;
      },
      (error: any) => {
        this.dialogLoading = false;
        this.errorCode = error.code;
        if (error.code == 1) {
          this.modalMessage =
            "Você precisa ativar a geolocalização para poder utilizar essa funcionalidade.";
          this.showModal = true;
        } else {
          this.modalMessage =
            "Não foi possível pegar a sua localização. Favor adicionar o endereço manualmente ou tente novamente.";
          this.showModal = true;
        }
      },
      { timeout: 10000 }
    );
  }

  getAddressComponents(place: Place): AddressComponents {
    const addressComponents: AddressComponents = {
      street: "",
      neighbourhood: "",
      city: "",
      state: "",
      zipCode: "",
      lat: "",
      lon: "",
    };

    if (place.address) {
      // Extração de Nominatim
      addressComponents.street = place.address.road || "";
      addressComponents.neighbourhood =
        place.address.neighbourhood || place.address.suburb || "";
      addressComponents.city =
        place.address.city || place.address.town || place.address.village || "";
      addressComponents.state =
        this.getStateAbbreviation(place.address.state) || "";
      addressComponents.zipCode = place.address.postcode || "";
      addressComponents.lat = place.lat ? place.lat.toString() : "";
      addressComponents.lon = place.lon ? place.lon.toString() : "";
    } else if (place.address_components) {
      // Extração de Google Maps
      const components = place.address_components;

      const streetComponent = components.find((comp: AddressComponent) =>
        comp.types.includes("route")
      );
      addressComponents.street = streetComponent
        ? streetComponent.long_name
        : "";

      const neighbourhoodComponent = components.find((comp: AddressComponent) =>
        comp.types.includes("sublocality_level_1")
      );
      addressComponents.neighbourhood = neighbourhoodComponent
        ? neighbourhoodComponent.long_name
        : "";

      const cityComponent = components.find((comp: AddressComponent) =>
        comp.types.includes("administrative_area_level_2")
      );
      addressComponents.city = cityComponent ? cityComponent.long_name : "";

      const stateComponent = components.find((comp: AddressComponent) =>
        comp.types.includes("administrative_area_level_1")
      );
      addressComponents.state = stateComponent ? stateComponent.short_name : "";

      const zipCodeComponent = components.find((comp: AddressComponent) =>
        comp.types.includes("postal_code")
      );
      addressComponents.zipCode = zipCodeComponent
        ? zipCodeComponent.long_name
        : "";

      if (place.geometry && place.geometry.location) {
        addressComponents.lat = place.geometry.location.lat().toString();
        addressComponents.lon = place.geometry.location.lng().toString();
      }
    }

    return addressComponents;
  }

  fillAddressAndNumber() {
    const self = this;
    this.cleanFields();

    // Get the place from Google Autocomplete
    self.place = self.googleMaps.getPlace();

    // Guard clause: ensure place exists and has address components
    if (!self.place || !self.place.address_components) {
      console.warn("No place selected or address_components not available");
      return;
    }

    const { address_components } = self.place;

    // Encontrar o índice do número da rua
    const streetNumberIndex: number = address_components.findIndex((n: any) =>
      n.types.includes("street_number")
    );

    // Encontrar o índice do bairro
    const neighIndex: number = address_components.findIndex((n: any) =>
      n.types.includes("sublocality_level_1")
    );

    // Verificar se o endereço é do DF
    const checkAddressDF: number = address_components.findIndex(
      (provincy: any) => provincy.short_name.includes("DF")
    );

    // Configurar o campo de endereço
    if (checkAddressDF !== -1) {
      self.addressInputDelivery =
        self.place.name + " - " + self.place.formatted_address;
    } else {
      self.addressInputDelivery = self.place.formatted_address;
      self.isDisabledComplement = false;
    }

    // Configurar o campo de número
    if (streetNumberIndex !== -1) {
      const streetNumber =
        self.place.address_components[streetNumberIndex].short_name;
      if (!streetNumber.includes("-")) {
        self.numberInputDelivery = streetNumber;
        self.isDisabledNumber = false;
      } else {
        self.isDisabledNumber = false;
      }
    } else {
      self.isDisabledNumber = false;
    }

    // Configurar o campo de bairro
    if (neighIndex !== -1) {
      self.neighInputDelivery = address_components[neighIndex].short_name;
      self.isDisabledNeighborhood = true;
    } else {
      self.isDisabledNeighborhood = false;
    }

    // Extract full address components using the helper function
    const addressComponents = this.getAddressComponents(self.place);
    self.streetInputDelivery = addressComponents.street;
    self.cityInputDelivery = addressComponents.city;
    self.provincyInputDelivery = addressComponents.state;
    self.cepInputDelivery = addressComponents.zipCode || "30130151";

    // If we don't have a neighborhood from Google components, use the extracted one
    if (!self.neighInputDelivery) {
      self.neighInputDelivery = addressComponents.neighbourhood;
    }

    // Extract latitude and longitude
    if (addressComponents.lat) {
      self.latitude = addressComponents.lat;
    }
    if (addressComponents.lon) {
      self.longitude = addressComponents.lon;
    }

    // Mark that a place was selected from Google Autocomplete
    self.placeSelected = true;
  }

  validateForm(provincy: string) {
    // Validate UF format - must be 2 uppercase letters
    if (
      !provincy ||
      provincy.length !== 2 ||
      !this.validUFs.includes(provincy.toUpperCase())
    ) {
      return false;
    }

    if (provincy === "DF") {
      if (
        String(this.oldStreetInputDelivery).toUpperCase() ==
        this.streetInputDelivery
      ) {
        return false;
      }
      return true;
    }

    if (
      String(this.oldNumberInputDelivery).toUpperCase() ==
        this.numberInputDelivery &&
      String(this.oldProvinceInputDelivery).toUpperCase() ==
        this.provincyInputDelivery &&
      String(this.oldCityInputDelivery).toUpperCase() ==
        this.cityInputDelivery &&
      String(this.oldNeighborhoodInputDelivery).toUpperCase() ==
        this.neighInputDelivery &&
      String(this.oldStreetInputDelivery).toUpperCase() ==
        this.streetInputDelivery &&
      String(this.oldComplementInputDelivery).toUpperCase() ==
        this.complementInputDelivery
    ) {
      return false;
    } else {
      if (
        this.provincyInputDelivery === "" ||
        this.cityInputDelivery === "" ||
        this.neighInputDelivery === "" ||
        this.streetInputDelivery === "" ||
        this.numberInputDelivery === ""
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  checkUpdateAddress() {
    let message = "Insira os seguintes dados:\n";
    let invalidAddr = false;

    // Check if we have valid address data (either from Google Places or manual input)
    if (this.addressInputDelivery === "" && !this.place) {
      this.mostraModal("Por favor, digite o endereço.", "error_outline");
      return;
    }

    if (this.place !== undefined && this.addressInputDelivery !== "") {
      const addressComponents = this.getAddressComponents(this.place);

      // Validação do endereço
      this.cepInputDelivery = addressComponents.zipCode || "30130151"; // Valor padrão caso não tenha CEP

      // Lógica de validação e atribuição
      if (addressComponents.state === "DF") {
        if (!addressComponents.city) {
          message = "Por favor, digite um endereço válido.";
          invalidAddr = true;
        } else {
          this.streetInputDelivery = `${addressComponents.street} - ${addressComponents.city}`;
          this.neighInputDelivery = addressComponents.neighbourhood || "";
          this.cityInputDelivery = addressComponents.city;
          this.provincyInputDelivery = addressComponents.state;
        }
      } else {
        if (addressComponents.street) {
          this.streetInputDelivery = addressComponents.street;
        } else {
          message += " - Rua\n";
          invalidAddr = true;
        }

        if (!this.numberInputDelivery) {
          message += " - Número\n";
          this.componentKey++;
          this.isDisabled = false;
          invalidAddr = true;
        }

        if (addressComponents.neighbourhood || this.neighInputDelivery) {
          this.neighInputDelivery =
            addressComponents.neighbourhood || this.neighInputDelivery;
        } else {
          message += " - Bairro\n";
          invalidAddr = true;
        }

        if (addressComponents.city) {
          this.cityInputDelivery = addressComponents.city;
        } else {
          message += " - Cidade\n";
          invalidAddr = true;
        }

        if (addressComponents.state) {
          this.provincyInputDelivery = addressComponents.state;
        } else {
          message += " - Estado\n";
          invalidAddr = true;
        }
      }

      // Mensagem de erro
      if (invalidAddr) {
        this.componentKey++;
        this.mostraModal(message, "error_outline");
        return;
      }

      // Latitude e longitude
      if (addressComponents.lat && addressComponents.lon) {
        this.latitude = addressComponents.lat;
        this.longitude = addressComponents.lon;
        sessionStorage.setItem("LATITUDE", this.latitude);
        sessionStorage.setItem("LONGITUDE", this.longitude);
      } else {
        this.mostraModal("Por favor, digite o endereço.", "error_outline");
        return;
      }

      // Validação final do formulário
      if (!this.validateForm(this.provincyInputDelivery)) {
        return;
      } else if (!sessionStorage.getItem("USER_ID")) {
        this.storeProvisoryAddress();
      } else {
        this.updateAddressDelivery();
        this.storeOnlyProvisoryAddress();
      }
    } else {
      this.mostraModal("Por favor, digite o endereço.", "error_outline");
      return;
    }
  }

  storeOnlyProvisoryAddress() {
    //sessionStorage.setItem("USE_CURRENT_LOCATION", "");
    const provisoryAddress: any = {
      STREET: this.streetInputDelivery,
      NEIGHBORHOOD: this.neighInputDelivery,
      CITY: this.cityInputDelivery,
      PROVINCY:
        this.provincyInputDelivery == "Paraná" ||
        this.provincyInputDelivery == "Parana"
          ? "PR"
          : this.provincyInputDelivery,
      CEP: this.cepInputDelivery,
      NUMBER: this.numberInputDelivery,
      COMPLEMENT: this.complementInputDelivery,
      LATITUDE: this.latitude,
      LONGITUDE: this.longitude,
      TYPE: "DELIVERY",
    };
    sessionStorage.setItem(
      "PROVISORY_ADDRESS",
      JSON.stringify(provisoryAddress)
    );
  }

  storeProvisoryAddress() {
    //sessionStorage.setItem("USE_CURRENT_LOCATION", "");
    const provisoryAddress: any = {
      STREET: this.streetInputDelivery,
      NEIGHBORHOOD: this.neighInputDelivery,
      CITY: this.cityInputDelivery,
      PROVINCY:
        this.provincyInputDelivery == "Paraná" ||
        this.provincyInputDelivery == "Parana"
          ? "PR"
          : this.provincyInputDelivery,
      CEP: this.cepInputDelivery,
      NUMBER: this.numberInputDelivery,
      COMPLEMENT: this.complementInputDelivery,
      LATITUDE: this.latitude,
      LONGITUDE: this.longitude,
      TYPE: "DELIVERY",
    };
    sessionStorage.setItem(
      "PROVISORY_ADDRESS",
      JSON.stringify(provisoryAddress)
    );
    sessionStorage.setItem(
      "USE_CURRENT_LOCATION",
      JSON.stringify(this.provisoryCurrentLocation)
    );
    let enteredAddAddressFrom =
      sessionStorage.getItem("ENTERED_ADD_ADDRESS_FROM") || "";
    enteredAddAddressFrom = enteredAddAddressFrom
      .trim()
      .replace("/", "")
      .replace(/^"+|"+$/g, "");

    if (enteredAddAddressFrom == "Lojas") {
      this.$router.go(-1);
    } else if (
      sessionStorage.getItem("ENTERED_DELIVER_LOCATION_FROM") == "Pedido" ||
      enteredAddAddressFrom == "DeliverLocation" ||
      enteredAddAddressFrom == "Pedido" ||
      enteredAddAddressFrom == "Produtos" ||
      enteredAddAddressFrom == "ListaDeProdutos"
    ) {
      sessionStorage.setItem("ENTERED_DELIVER_LOCATION_FROM", "");
      sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "");
      sessionStorage.setItem("UPDATE_PRICE", "true");
      this.$router.replace("Pedido");
    } else if (
      sessionStorage.getItem("ENTERED_DELIVER_LOCATION_FROM") == "Produto"
    ) {
      sessionStorage.setItem("UPDATE_PRICE", "true");
      this.$router.replace("Pedido");
    } else if (enteredAddAddressFrom == "Home") {
      sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "");
      this.$router.replace("Lojas");
    } else if (sessionStorage.getItem("MANUAL_ADDRESS") == "true") {
      this.$router.replace("Lojas");
      sessionStorage.setItem("MANUAL_ADDRESS", "false");
    } else {
      sessionStorage.getItem("ENTERED_FROM_ENABLE_LOCATION")
        ? this.goToHomeLayout()
        : this.$router.go(-1);
    }
  }

  updateAddressDelivery() {
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID") || "",
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN") || "",
      STREET: this.streetInputDelivery,
      NEIGHBORHOOD: this.neighInputDelivery,
      CITY: this.cityInputDelivery,
      PROVINCY: this.provincyInputDelivery,
      CEP: this.cepInputDelivery,
      NUMBER: this.numberInputDelivery,
      COMPLEMENT: this.complementInputDelivery,
      LATITUDE: this.latitude,
      LONGITUDE: this.longitude,
      TYPE: "DELIVERY",
      TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT") || "",
    };
    req.route = "requestAddressChange";
    req.visibilityOptions = { success: false, error: false, loading: true };
    req.callbackSuccess = (response: any) => {
      if (response.status.status.status == "A") {
        sessionStorage.setItem("USE_CURRENT_LOCATION", "");
        let deliveryAddress = this.userData.ADDRESS.find(
          (address: any) => address.TYPE == "DELIVERY"
        );
        if (!deliveryAddress) {
          this.userData.ADDRESS.push({ TYPE: "DELIVERY" });
          deliveryAddress = this.userData.ADDRESS.find(
            (address: any) => address.TYPE == "DELIVERY"
          );
        }
        deliveryAddress.CEP = this.cepInputDelivery;
        deliveryAddress.NUMBER = this.numberInputDelivery;
        deliveryAddress.STREET = this.streetInputDelivery;
        deliveryAddress.NEIGHBORHOOD = this.neighInputDelivery;
        deliveryAddress.PROVINCY = this.provincyInputDelivery;
        deliveryAddress.CITY = this.cityInputDelivery;
        deliveryAddress.COMPLEMENT = this.complementInputDelivery;
        deliveryAddress.ID = response.status.status.id;
        deliveryAddress.LATITUDE = this.latitude;
        deliveryAddress.LONGITUDE = this.longitude;

        sessionStorage.setItem("USER_DATA", JSON.stringify(this.userData));
        this.$toast("Dados atualizados com sucesso", {
          type: TYPE.SUCCESS,
        });

        let enteredAddAddressFrom =
          sessionStorage.getItem("ENTERED_ADD_ADDRESS_FROM") || "";
        enteredAddAddressFrom = enteredAddAddressFrom
          .trim()
          .replace("/", "")
          .replace(/^"+|"+$/g, "");

        if (enteredAddAddressFrom == "Lojas") {
          this.$router.go(-1);
        } else if (
          sessionStorage.getItem("ENTERED_DELIVER_LOCATION_FROM") == "Pedido" ||
          enteredAddAddressFrom == "DeliverLocation" ||
          enteredAddAddressFrom == "Pedido" ||
          enteredAddAddressFrom == "Produtos" ||
          enteredAddAddressFrom == "ListaDeProdutos"
        ) {
          sessionStorage.setItem("ENTERED_DELIVER_LOCATION_FROM", "");
          sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "");
          sessionStorage.setItem("UPDATE_PRICE", "true");
          this.$router.replace("Pedido");
        } else if (enteredAddAddressFrom == "Home") {
          sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "");
          this.$router.replace("Lojas");
        } else {
          sessionStorage.getItem("ENTERED_FROM_ENABLE_LOCATION")
            ? this.goToHomeLayout()
            : this.$router.go(-1);
        }
      }
    };
    req.callbackError = function (error: any) {
      this.$toast("Não foi possível alterar os dados, tente novamente.", {
        type: TYPE.ERROR,
      });
      console.log(error);
    };
    req.loadingMessage = "Atualizando o endereço...";
    req.blockTouchEvents = true;
    req.send();
  }

  getStateAbbreviation(stateName = ""): string | null {
    const states: { [key: string]: string } = {
      Acre: "AC",
      Alagoas: "AL",
      Amapá: "AP",
      Amazonas: "AM",
      Bahia: "BA",
      Ceará: "CE",
      "Distrito Federal": "DF",
      "Espírito Santo": "ES",
      Goiás: "GO",
      Maranhão: "MA",
      "Mato Grosso": "MT",
      "Mato Grosso do Sul": "MS",
      "Minas Gerais": "MG",
      Pará: "PA",
      Paraíba: "PB",
      Paraná: "PR",
      Pernambuco: "PE",
      Piauí: "PI",
      "Rio de Janeiro": "RJ",
      "Rio Grande do Norte": "RN",
      "Rio Grande do Sul": "RS",
      Rondônia: "RO",
      Roraima: "RR",
      "Santa Catarina": "SC",
      "São Paulo": "SP",
      Sergipe: "SE",
      Tocantins: "TO",
    };

    const abbreviation = states[stateName];
    return abbreviation || null;
  }

  isDifferentLocationWithMargin(
    userLat: number,
    userLng: number,
    deviceLat: number,
    deviceLng: number,
    marginMeters: number
  ): boolean {
    const toRadians = (degrees: number): number => (degrees * Math.PI) / 180;

    const earthRadiusMeters = 6371000; // Raio da Terra em metros
    const deltaLat = toRadians(deviceLat - userLat);
    const deltaLng = toRadians(deviceLng - userLng);

    const a =
      Math.sin(deltaLat / 2) ** 2 +
      Math.cos(toRadians(userLat)) *
        Math.cos(toRadians(deviceLat)) *
        Math.sin(deltaLng / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadiusMeters * c;

    // Verifica se a distância calculada é maior que a margem
    return distance > marginMeters;
  }

  beforeDestroy() {
    sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "");
  }
}
